// extracted by mini-css-extract-plugin
export var changeIcon = "_4i-4";
export var container = "_4i-0";
export var divider = "_4i-7";
export var externalLinkIcon = "_4i-1";
export var green = "_4i-5";
export var helpCircleIcon = "_4i-3";
export var iconButton = "_4i-2";
export var red = "_4i-6";